module.exports = __webpack_public_path__ + "static/media/seleccionar-reclamos.7f2ee8fd.svg";